import gql from 'graphql-tag';

export interface BankAccounts {
  bank_name: string;
  bank_branch: string;
  account_name: string;
  account_number: string;
}

export interface BankAccountsData {
  getBankAccounts: {
    getBankAccounts: BankAccounts[];
  };
}

export interface BankAccountsVars {
  payable?: number;
  receivable?: number;
}

export default gql`
  query getBankAccounts($payable: Int, $receivable: Int) {
    getBankAccounts(payable: $payable, receivable: $receivable) {
      getBankAccounts {
        bank_name
        bank_branch
        account_name
        account_number
      }
    }
  }
`;
